module.exports = __webpack_public_path__ + "39692a18a7607cbc93fce2149195ea27.pdf";